import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardImg,
  Col,
  Row,
  Table,
  Badge,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
// import { useGetEmployeeDropDownQuery } from "slices/employee/employeeSlice";
// import { useGetProjectsQuery } from "slices/employee/employeeSlice";
// import { useGetCompaniesQuery } from "slices/InspectionReport/InspectionReportSlice";
import { BadgeStatus } from "helpers/badgeStatus";
import { STATUS_COLORS } from "helpers/common_helper";
import { formatDateTime } from "helpers/date_utils";

import {
  useGetToolboxMeetingByIdQuery,
  useUpdateToolboxAttendanceMutation,
  useUpdateToolboxMeetingMutation,
} from "slices/safetyApp/safetyappSlice";

import { useDeleteToolboxAttendanceMutation } from "slices/safetyApp/safetyappSlice";
import AddMultipleEmployeeModal from "pages/SafetyApp/CommonWizardSteps/SteperModals/AddMultipleEmployeeModal";
import { IsValidPermissions } from "Routes/AuthProtected";

interface OverviewProps {
  toolboxMeetingByIdData: any;
}

const OverviewTab: React.FC<OverviewProps> = ({ toolboxMeetingByIdData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(
    null,
  );
  const [comments, setComments] = useState<string>("");

  // State for delete modal
const [deleteModal, setDeleteModal] = useState(false);
const [employeeToDelete, setEmployeeToDelete] = useState(null);

console.log('employeeToDelete',employeeToDelete)

// Toggle delete modal
const toggleDeleteModal = () => setDeleteModal(!deleteModal);

// Handle delete button click
const handleDeleteClick = (attendance:any) => {
  setEmployeeToDelete(attendance);
  toggleDeleteModal();
};

const handleConfirmDelete = async () => {
  if (!employeeToDelete) return;
  
  try {
    const response = await updateToolboxAttendance({
      toolbox_id: toolboxMeetingByIdData?.toolbox_id,
      attendanceData: {
        delete_flag:true,
        //@ts-ignore
        employee_list: [employeeToDelete.employee.id] // Send just the attendance record ID in an array
      },
    }).unwrap();
    
    refetch();
    toggleDeleteModal();
    setEmployeeToDelete(null);
  } catch (error) {
    console.error("Error updating employee attendance:", error);
  }
};

  const {
    data: toolboxData,
    isLoading: isToolboxLoading,
    refetch,
  } = useGetToolboxMeetingByIdQuery(toolboxMeetingByIdData?.toolbox_id);

  const [
    updateToolboxAttendance,
    { isLoading: updateToolboxAttendanceLoading },
  ] = useUpdateToolboxAttendanceMutation();
  const [updateToolboxMeeting, { isLoading: isSubmitting }] =
    useUpdateToolboxMeetingMutation();
  const [deleteToolboxMeeting, { isLoading: isdeleting }] =
    useDeleteToolboxAttendanceMutation();

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleAddEmployee = async (employeeList: any) => {
    try {
      const response = await updateToolboxAttendance({
        toolbox_id: toolboxMeetingByIdData?.toolbox_id,
        attendanceData: {
          employee_list: employeeList,
        },
      }).unwrap();
      refetch();
      // setAddedEmployees((prev) => [...prev, response]);
      setSelectedEmployeeId(null);
      toggleModal();
    } catch (error) {
      console.error("Error adding employee:", error);
    }
  };

  const handleDeleteEmployee = async (employeeId: number) => {
    try {
      await deleteToolboxMeeting({
        id: employeeId,
      }).unwrap();
      refetch();
    } catch (error) {
      console.error("Error deleting employee:", error);
    }
  };

  const handleSubmit = async () => {
    // if (location.latitude === null || location.longitude === null) {
    //   alert("Unable to fetch your location. Please try again or Reload Page.");
    //   return;
    // }

    try {
      await updateToolboxMeeting({
        toolbox_id: toolboxMeetingByIdData?.toolbox_id,
        updatedMeetingData: {
          report_status: toolboxMeetingByIdData?.report_status,
        },
      }).unwrap();
      setSubmitted(true);
    } catch (error) {
      console.error("Failed to submit", error);
    }
  };

  const formatNumberedText = (inputText: any) => {
    return inputText?.replace(/(\d+)\./g, "\n$1.");
  };
  return (
    <React.Fragment>
      <Row>
        <Col xl={12} lg={12}>
          <Card>
            <CardBody>
              <div className="text-muted">
                <h5 className="mt-2">Tool Box Meeting Details</h5>
                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Company :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.contractor}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Project :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.project_name}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Conducted By :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.conducted_by_name}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Submission Status :</b>{" "}
                          {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.report_status_name ? (
                            <BadgeStatus
                              value={toolboxMeetingByIdData?.report_status_name}
                              color={
                                STATUS_COLORS[
                                toolboxMeetingByIdData?.report_status_name
                                ]
                              }
                            />
                          ) : null}
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Start Date of Work :</b>{" "}
                          {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {formatDateTime(
                            toolboxMeetingByIdData?.start_date_of_work,
                            "date",
                          )}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Start Time of Work :</b>{" "}
                          {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {formatDateTime(
                            toolboxMeetingByIdData?.start_time_of_work,
                            "time",
                          )}
                        </h5>
                      </div>
                    </Col>

                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>End Date of Work :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {formatDateTime(
                            toolboxMeetingByIdData?.end_date_of_work,
                            "date",
                          )}
                        </h5>
                      </div>
                    </Col>

                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>End Time of Work :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {formatDateTime(
                            toolboxMeetingByIdData?.end_time_of_work,
                            "time",
                          )}
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>

                <div className="pt-3 border-top border-top-dashed mt-4">
                  <Row>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Submitted By :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.submited_by_name}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Submitted Date Time :</b>{" "}
                          {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {formatDateTime(
                            toolboxMeetingByIdData?.submit_date,
                            "datetime",
                          )}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Submitted Location :</b>{" "}
                          {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.location}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={3} sm={6}>
                      <div>
                        <p className="mb-2 text-uppercase fw-medium">
                          <b>Work Description :</b> {/*  Made the label bold */}
                        </p>
                        <h5 className="fs-15 mb-0">
                          {toolboxMeetingByIdData?.work_description}
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>
                {toolboxMeetingByIdData?.toolbox_comments ? (
                  <div className="pt-3 border-top border-top-dashed mt-4">
                    <Row>
                      <Col lg={6} sm={12}>
                        <div>
                          <p className="mb-2 text-uppercase fw-medium">
                            <b>Comments :</b> {/*  Made the label bold */}
                          </p>
                          <div
                            className="fs-15 mb-0"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            {formatNumberedText(
                              toolboxMeetingByIdData?.toolbox_comments,
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={12} lg={12}>
          <Card>
            <CardHeader className="d-flex align-items-center justify-content-between">
              <h5 className="mt-2">Tool Box Attendance Details</h5>
              {(toolboxMeetingByIdData?.report_status_name === "Linked" ||
                toolboxMeetingByIdData?.report_status_name === "Submitted") && (
                  <Button
                    color="success"
                    onClick={toggleModal}
                    className="mb-3 float-end"
                  >
                    Add Employee
                  </Button>
                )}
            </CardHeader>
            <CardBody>
              <hr />
              <Row className="mt-4">
                <Col md={12}>
                  <Table
                    className="table-borderless align-middle mb-0 table-responsive"
                    responsive
                  >
                    <thead className="table-light">
                      <tr>
                        <th scope="col">#No</th>
                        <th scope="col">Action</th>
                        <th scope="col">Emp #No</th>
                        <th scope="col">NRIC/FIN</th>
                        <th scope="col">Name</th>
                        <th scope="col">Designation</th>

                        {toolboxData?.health_declaration?.map(
                          (declaration: any, index: number) => (
                            <th
                              scope="col"
                              key={index}
                              style={{ minWidth: 150, textAlign: "center" }}
                            >
                              {formatDateTime(
                                declaration?.declaration_date,
                                "datetime",
                              )}
                            </th>
                          ),
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {toolboxData?.toolbox_attendance?.length > 0 ? (
                        toolboxData.toolbox_attendance.map(
                          (attendance: any, index: number) => {
                            // Find matching health statuses for the current employee
                            const employeeStatuses =
                              toolboxData.health_declaration.map(
                                (declaration: any) =>
                                  declaration.statuses.find(
                                    (status: any) =>
                                      status.employee_number ===
                                      attendance?.employee?.employee_number,
                                  ),
                              );
                            return (
                              <tr
                                key={index}
                                style={
                                  !attendance?.active_flag
                                    ? { background: "#FFD0C7" }
                                    : {}
                                }
                              >
                                <td>{index + 1}</td>
                                <td>
                                  {attendance?.active_flag && (
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() => handleDeleteClick(attendance)}
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                    </Button>
                                  )}
                                </td>
                                <td>{attendance?.employee?.employee_number}</td>
                                <td>{attendance?.employee?.nric_mask}</td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    {attendance?.employee
                                      .employee_profile_url ? (
                                      <div className="flex-shrink-0">
                                        <img
                                          src={
                                            attendance?.employee
                                              .employee_profile_url
                                          }
                                          alt=""
                                          className="avatar-xs rounded-circle"
                                        />
                                      </div>
                                    ) : (
                                      <div className="flex-shrink-0 avatar-xs">
                                        <div className="avatar-title bg-danger-subtle text-danger rounded-circle fs-13">
                                          {attendance?.employee.employee_fullname.charAt(
                                            0,
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    <div className="flex-grow-1 ms-2">
                                      <h6 className="mb-1">
                                        {attendance?.employee.employee_fullname}
                                      </h6>
                                    </div>
                                  </div>
                                </td>
                                <td>{attendance?.employee.position_name}</td>

                                {/* Render health statuses */}
                                {employeeStatuses.map(
                                  (status: any, idx: number) => (
                                    <td key={idx} className="text-center">
                                      {status?.health_status === 1 ? (
                                        <Badge color="success fs-11 text-uppercase">
                                          Fit
                                        </Badge>
                                      ) : status?.health_status === 2 ? (
                                        <Badge color="danger fs-11 text-uppercase">
                                          Not Fit
                                        </Badge>
                                      ) : (
                                        <Badge color="secondary fs-11 text-uppercase">
                                          Not Present
                                        </Badge>
                                      )}
                                    </td>
                                  ),
                                )}
                              </tr>
                            );
                          },
                        )
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">
                            No employee attendance added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </CardBody>
          </Card>

          {/* Delete Confirmation Modal */}
          <Modal isOpen={deleteModal} toggle={toggleDeleteModal}>
            <ModalHeader toggle={toggleDeleteModal}>Confirm Delete</ModalHeader>
            <ModalBody>
              Are you sure you want to remove this employee from the attendance list?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleDeleteModal}>
                Cancel
              </Button>
              <Button color="danger" onClick={handleConfirmDelete}>
              {updateToolboxAttendanceLoading ? <Spinner size="sm" /> : "Delete"}
              </Button>
            </ModalFooter>
          </Modal>
        </Col>
      </Row>
      <AddMultipleEmployeeModal
        isModalOpen={isModalOpen}
        handleModalToggle={toggleModal}
        projectId={toolboxMeetingByIdData?.project}
        submitLoading={updateToolboxAttendanceLoading}
        handleSubmit={handleAddEmployee}
      />
    </React.Fragment>
  );
};

export default OverviewTab;
